import { MessageCircle } from "lucide-react";
import { CONTACT } from "@/data/products";

const WhatsAppFloat = () => (
  <a
    data-testid="floating-whatsapp-btn"
    href={`${CONTACT.whatsapp}?text=${encodeURIComponent("Namaste! I have a question about Raj Kumari Kirana Store.")}`}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat on WhatsApp"
    className="fixed bottom-6 right-6 z-50 group"
  >
    <span className="absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-40 animate-ping" />
    <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-lg shadow-[#25D366]/30 group-hover:scale-110 transition-transform duration-300">
      <MessageCircle size={26} />
    </span>
  </a>
);

export default WhatsAppFloat;
